import { DefaultState, IState } from "./state";
import { Keys, Types } from "./actions/types";
import { contact, emptyContact, contactPaginationResponse, auth0contactError } from '../../../model/contact';
import { myroom } from "../../../model/myroom";
import moment from "moment";

const sanifyContact = (c: contact): contact => {
    let s = emptyContact();
    Object.keys(c).forEach(key => {
        if (c[key]) {
            s[key] = c[key];
        }
    })

    return s;
}


export const reducer = (state: IState = DefaultState(), action: Types): IState => {
    switch (action.type) {
        // case Keys.GREENPASS_PENDING: {
        //     return {
        //         ...state,
        //         contacts: [],
        //         isLoadingContacts: true,
        //     }
        // }
        // case Keys.LOADCONTACTS_FULFILLED: {
        //     let p: Array<contact> = action.payload;
        //     return {
        //         ...state,
        //         contacts: p,
        //         // ZZ selectedContact: p.length > 0 ? p[0] : undefined,
        //         contact: p.length > 0 ? p[0] : undefined,
        //         isLoadingContacts: false,
        //     }
        // }
        // case Keys.LOADCONTACTS_REJECTED: {
        //     return {
        //         ...state,
        //         contacts: [],
        //         isLoadingContacts: false,
        //     }
        // }
        case Keys.LOADCONTACTS_PENDING: {
            return {
                ...state,
                contacts: [],
                isLoadingContacts: true,
            }
        }
        case Keys.LOADCONTACTS_FULFILLED: {
            let p: Array<contact> = action.payload;
            return {
                ...state,
                contacts: p,
                // ZZ selectedContact: p.length > 0 ? p[0] : undefined,
                contact: p.length > 0 ? p[0] : undefined,
                isLoadingContacts: false,
            }
        }
        case Keys.LOADCONTACTS_REJECTED: {
            return {
                ...state,
                contacts: [],
                isLoadingContacts: false,
            }
        }
        case Keys.LOADRECENTCONTACTS_PENDING: {
            return {
                ...state,
                recentContacts: [],
                isLoadingContacts: true,
            }
        }
        case Keys.LOADRECENTCONTACTS_FULFILLED: {
            let p: Array<contact> = action.payload;
            return {
                ...state,
                recentContacts: p,
                isLoadingContacts: false,
            }
        }
        case Keys.LOADRECENTCONTACTS_REJECTED: {
            return {
                ...state,
                recentContacts: [],
                isLoadingContacts: false,
            }
        }
        case Keys.LOADCONTACTSPAGINATED_PENDING: {
            return {
                ...state,
                contacts: [],
                page: action.meta,
                totalRows: 0,
                isLoadingContacts: true,
            }
        }
        case Keys.LOADCONTACTSPAGINATED_FULFILLED: {
            let p: contactPaginationResponse = action.payload;
            return {
                ...state,
                contacts: p.contacts,
                // ZZ selectedContact: p.contacts.length > 0 ? p.contacts[0] : undefined,
                contact: p.contacts.length > 0 ? p.contacts[0] : undefined,
                totalRows: p.totalRows,
                isLoadingContacts: false,
            }
        }
        case Keys.LOADCONTACTSPAGINATED_REJECTED: {
            return {
                ...state,
                contacts: [],
                totalRows: 0,
                isLoadingContacts: false,
            }
        }

        //case ReminderKeys.ADDBLOCKACCESSDATE as Types: {
        case Keys.ADDBLOCKACCESSDATE: {
            let p: Date = action.payload;
            // console.info("------------------------------------------------")
            // 2020-10-13T22:00:00Z
            // console.info(p);

            let id = state.contact.sub;
            let toBeAltered = state.contacts
                .find(contact => contact.sub === id);

            if (toBeAltered)
                toBeAltered.blockAccessOn = moment("2020-10-13T22:00:00Z").toDate();

            return {
                ...state,
                setBlockDate: p,
                // contact: toBeAltered
            }
            // return {
            //     ...state,
            //     contact: {...state.contact, blockAccessOn: moment(p).toDate()}
            // }
            // return {
            //     ...state,
            //     contacts: []
            // }
        }

        case Keys.ADDNEWUSER_PENDING: {
            return {
                ...state,
                contact: undefined,
                isLoadingContact: true,
                isContactFetchInError: false
            }
        }
        case Keys.ADDNEWUSER_FULFILLED: {
            let p: contact = sanifyContact(action.payload);
            let contacts = [...state.contacts];
            contacts.push(p);
            return {
                ...state,
                contact: p,
                contacts: contacts,
                isLoadingContact: false,
                isContactFetchInError: false
            }
        }
        case Keys.ADDNEWUSER_REJECTED: {
            return {
                ...state,
                isLoadingContact: false,
                // isContactFetchInError: true
            }
        }
        case Keys.LOADCONTACT_PENDING: {
            return {
                ...state,
                contact: undefined,
                setBlockDate: undefined,
                isLoadingContact: true,
                isContactFetchInError: false
            }
        }
        case Keys.LOADCONTACT_FULFILLED: {
            // HERE
            let p: contact = sanifyContact(action.payload);
            let toBeAltered = state.contacts
                .find(contact => contact.sub === p.sub);
            if (toBeAltered)
                p.connectionId = toBeAltered.connectionId;
            return {
                ...state,
                contact: p,
                setBlockDate: p.blockAccessOn,
                isLoadingContact: false,
                isContactFetchInError: false,
            }
        }
        case Keys.LOADCONTACT_REJECTED: {
            // AND HERE
            let c: auth0contactError = { error: action.payload, id: '', mail: '', verifiedMail: false };
            console.log("Keys.LOADCONTACT_REJECTED", action.payload)
            try {
                c = action.payload;
            }
            catch (error) {

            }
            return {
                ...state,
                contact: undefined,
                auth0contactError: c,
                setBlockDate: undefined,
                isLoadingContact: false,
                isContactFetchInError: true
            }
        }
        case Keys.USERCONNECTED: {
            const { sub, connId }: { sub: string, connId: string } = action.payload;
            let contacts = [...state.contacts];
            let found = contacts.find(c => c.sub === sub);
            if (found)
                found.connectionId = connId;

            let recentContacts = [...state.recentContacts];
            found = recentContacts.find(c => c.sub === sub);
            if (found)
                found.connectionId = connId;
            return {
                ...state,
                contacts: contacts,
                recentContacts: recentContacts
            }
        }

        case Keys.USERDISCONNECTED: {
            const sub: string = action.payload;

            let contacts = [...state.contacts];
            let found = contacts.find(c => c.sub === sub);
            if (found)
                found.connectionId = null;

            let recentContacts = [...state.recentContacts];
            found = recentContacts.find(c => c.sub === sub);
            if (found)
                found.connectionId = null;

            return {
                ...state,
                contacts: contacts,
                recentContacts: recentContacts
            }
        }
        case Keys.CLEARSELECTION: {
            return {
                ...state,
                contact: undefined,
            }
        }
        //
        case Keys.ADDROOM_PENDING: {
            return {
                ...state,
                contact: undefined,
                isLoadingContact: true,
                isContactFetchInError: false
            }
        }
        case Keys.ADDROOM_FULFILLED: {
            let p: contact = sanifyContact(action.payload);
            let toBeAltered = state.contacts
                .find(contact => contact.sub === p.sub);
            if (toBeAltered)
                p.connectionId = toBeAltered.connectionId;
            /*AGGIORNAMENTO LATO FE PERCHE' LATO BE SE LA CHIAMATA E' TROPPO VELOCE
            RESTITUISCE IL CONTATTO SENZA AVER ESEGUITO LA MODIFICA*/
            if (p.rooms) {
                let room: myroom = action.meta;
                let index = (p.rooms as myroom[]).findIndex(r => r._id === room._id);
                if (index >= 0) {
                    p.rooms[index] = room;
                } else {
                    p.rooms.push(room);
                }
            }
            //AGGIORNO LISTA
            let contacts = state.contacts;
            let index = contacts.findIndex(c => c.sub === p.sub);
            if (index >= 0) {
                contacts[index] = p;
            }
            return {
                ...state,
                contact: p,
                contacts: contacts,
                isLoadingContact: false,
                isContactFetchInError: false
            }
        }
        case Keys.ADDROOM_REJECTED: {
            return {
                ...state,
                contact: undefined,
                isLoadingContact: false,
                isContactFetchInError: true
            }
        }
        case Keys.DELETEROOM_PENDING: {
            return {
                ...state,
                contact: undefined,
                isLoadingContact: true,
                isContactFetchInError: false
            }
        }
        case Keys.DELETEROOM_FULFILLED: {

            let p: contact = sanifyContact(action.payload);
            let toBeAltered = state.contacts
                .find(contact => contact.sub === p.sub);
            if (toBeAltered)
                p.connectionId = toBeAltered.connectionId;
            /*AGGIORNAMENTO LATO FE PERCHE' LATO BE SE LA CHIAMATA E' TROPPO VELOCE
       RESTITUISCE IL CONTATTO SENZA AVER ESEGUITO LA MODIFICA*/
            if (p.rooms) {
                let roomDeletedId: string = action.meta;
                p.rooms = (p.rooms as myroom[]).filter(r => r._id !== roomDeletedId);
            }
            //AGGIORNO LISTA
            let contacts = state.contacts;
            let index = contacts.findIndex(c => c.sub === p.sub);
            if (index >= 0) {
                contacts[index] = p;
            }
            return {
                ...state,
                contact: p,
                isLoadingContact: false,
                isContactFetchInError: false
            }
        }
        case Keys.DELETEROOM_REJECTED: {
            return {
                ...state,
                contact: undefined,
                isLoadingContact: false,
                isContactFetchInError: true
            }
        }
        case Keys.UPDATEROOM_PENDING: {
            return {
                ...state,
                contact: undefined,
                isLoadingContact: true,
                isContactFetchInError: false
            }
        }
        case Keys.UPDATEROOM_FULFILLED: {
            let p: contact = sanifyContact(action.payload);
            let toBeAltered = state.contacts
                .find(contact => contact.sub === p.sub);
            if (toBeAltered)
                p.connectionId = toBeAltered.connectionId;
            /*AGGIORNAMENTO LATO FE PERCHE' LATO BE SE LA CHIAMATA E' TROPPO VELOCE
            RESTITUISCE IL CONTATTO SENZA AVER ESEGUITO LA MODIFICA*/
            if (p.rooms) {
                let room: myroom = action.meta;
                let index = (p.rooms as myroom[]).findIndex(r => r._id === room._id);
                if (index >= 0) {
                    p.rooms[index] = room;
                }
            }
            //AGGIORNO LISTA
            let contacts = state.contacts;
            let index = contacts.findIndex(c => c.sub === p.sub);
            if (index >= 0) {
                contacts[index] = p;
            }
            return {
                ...state,
                contact: p,
                contacts: contacts,
                isLoadingContact: false,
                isContactFetchInError: false
            }
        }
        case Keys.UPDATEROOM_REJECTED: {
            return {
                ...state,
                contact: undefined,
                isLoadingContact: false,
                isContactFetchInError: true
            }
        }
        case Keys.LOADCONTACTRESERVATIONS_PENDING: {
            return {
                ...state,
                contactReservations: [],
                isLoadingContactReservations: true,
                isContactReservationFetchInError: false
            }
        }
        case Keys.LOADCONTACTRESERVATIONS_FULFILLED: {
            return {
                ...state,
                contactReservations: action.payload,
                isLoadingContactReservations: false,
            }
        }
        default:
            return state;
    }
}